import { SourceFilter } from "types/Models/books";

export const isSourceConnected = (
  source: SourceFilter,
  connectionStatusByBrand: Record<string, boolean>
): boolean => connectionStatusByBrand[source.brand_name] ?? true;
